import { Component, OnInit, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ErrorStateMatcher } from '@angular/material/core';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ConfirmDialogComponent } from './../../../../common/components/confirm-dialog/confirm-dialog.component';
import { SliderModelService } from './../../../../services/infrastructure/sliderModel.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LolLoggerService } from './../../../../common/shared/lol-logger.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { CommonService } from './../../../../services/common/common.service';
import * as $ from 'jquery';
import { SeedReservationService } from '../../../../../../src/app/services/seed/seed-reservation.service';
import { SeedReplantService } from '../../../../services/seed/seed-replant/seed-replant.service';
import { DashboardFilter } from './../../../../models/DashboardFilter';

@Component({
  selector: 'app-seed-reservation-create',
  templateUrl: './seed-reservation-create.component.html',
  styleUrl: './seed-reservation-create.component.scss'
})

export class SeedReservationCreateComponent implements OnInit, AfterViewInit, OnDestroy {
  // ===============================
  // ✅ Primitive Type Variables
  // ===============================
  showTabs = false;
  shipToDataLoading: boolean = true;
  sellerDataLoading: boolean = false;
  hasChangeAdded = false;
  isPlaceOrderDisable = true;
  isNotValid = false;
  isAddingNewItem = false;
  readOnlyAccess = false;
  selectedCount = 0;
  searchCount = 0;
  firstLoad: number = 0;
  tabNode: '';
  newItemName = '';
  emailAddress: string;
  duplicateCombinationError: string;
  dataCount = 0;
  selectedItemId: number | null = null;
  retailerId: string;
  res: string;
  // ===============================
  // ✅ Array Type Variables
  // ===============================
  subscription = new Array<Subscription>();
  productList: any[] = [];
  marketingBrandList: any[] = [];
  ddldeliveryList = [
    { id: 'Y', value: 'Yes' },
    { id: 'N', value: 'No' }
  ];
  selectedItems: any[] = [];
  dataSource = [...this.selectedItems];
  displayedColumns: string[] = ['select', 'productLine', 'marketingBrand', 'labelQty'];
  confirmationMsg: string = "";

  // ===============================
  // ✅ Object / Any Type Variables
  // ===============================
  shipToData: any;
  sellerData: any;
  userMenuAccessList: any;
  formdata: any;
  growerLoading: any;
  growerList: any;
  headerYear: any;
  shipToAccount: any;
  selectedProductLineId: any;
  selectedMarketingBrandId: any;
  growerSliderSubscription: any;

  // ===============================
  // ✅ Constant / Class Instances
  // ===============================
  dashboardFilter: DashboardFilter;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  matcher = new InputErrorStateMatcher(this.isNotValid);
  

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    private commonService: CommonService,
    private datePipe: DatePipe,
    public broadcastService: BroadcastService,
    private configService: ConfigService,
    public sliderModelService: SliderModelService,
    public seedReservationService: SeedReservationService,
    public seedReplantService: SeedReplantService) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit(): void {
    this.setDefaultformData()
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.SEED_RESERVATION)) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_RESERVATION, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.getShipToData();
          this.getProductList();
        }
        else {
          this.router.navigate(['/cc/landing-data']);
        }
      }
    }

    this.growerSliderSubscription = this.sliderModelService.gmkValue.subscribe(x => {
      this.formdata.gmk = +x;
      this.getGrowerListByAccount();      
      const event = { gmk: this.formdata.gmk }; 
      this.onGrowerSelection(event);
    }, error => { LolLoggerService.error(error); });

  }

  ngAfterViewInit() {
    this.setTableHeight();
    this.setHeight();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setTableHeight();
    this.setHeight();
  }

  setHeight() {
    if (window.innerWidth < 767) {
      const templateHeight = window.innerHeight - 200;
      $('.productLabelFormPage').css('max-height', templateHeight + 'px');
    }
  }

  setTableHeight() {
    setTimeout(function () {
      const templateMinHeight = window.innerHeight - $('h3').outerHeight() - $('.OrderReleaseTop').outerHeight() - $('.productsection').outerHeight() - 190;
      const templateMaxHeight = window.innerHeight - $('h3').outerHeight() - $('.OrderReleaseTop').outerHeight() - $('.productsection').outerHeight() - 189;

      $('.tableOuterContainer').css('min-height', templateMinHeight + 'px');
      $('.tableOuterContainer').css('max-height', templateMaxHeight + 'px');
    }, 100);
  }

  setDefaultformData() {
    this.formdata = {
      accountNumber: null,
      parentAccountNumber: null,
      accountName: null,
      address: null,
      city: null,
      state: null,
      zipCode: null,
      overNightDelivery: "N",
      orderedBy: null,
      accountManager: null,
      attn: null,
      email: null,
      customerPO: null,
      orderedDate: this.datePipe.transform(new Date(), 'MM/dd/yyyy'),
      cppproductLabelItems: []
    };
  }

  getShipToData() {
    this.subscription.push(this.seedReservationService
      .getAccountList()
      .subscribe(
        (result: any) => {
          this.shipToData = result;
          this.shipToDataLoading = false;
        },
        (error) => LolLoggerService.error(error)
      ));
  }

  getSalesRepresentativeDetails() {
    this.sellerDataLoading = true;
    this.subscription.push(this.seedReservationService
      .getSalesAccountList(this.shipToAccount)
      .subscribe(
        (result: any) => {
          this.sellerData = result?.sort((a, b) => (a?.sellerAccountName ?? '').localeCompare(b?.sellerAccountName ?? ''));
          this.sellerDataLoading = false;
        },
        (error) => LolLoggerService.error(error)
      ));
  }
  getRetailerAccountID(accounNumber: number, growerID: number) {
    this.subscription.push(this.seedReservationService
      .getRetailAccountID(accounNumber, growerID)
      .subscribe(
        (result: { retailerAccountId: string }) => {
          this.retailerId = result.retailerAccountId;
          this.formdata.retailAccountID = result.retailerAccountId;
        },
        (error) => LolLoggerService.error(error)
      ));
  }

  growerSearchFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    return (item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf(term) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf(term) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf(term) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf(term) > -1);
  }

  getGrowerListByAccount() {
    this.growerLoading = true;
    const growerFilters = { 'GrowerGLN': '', 'GrowerName': '' };
    this.dashboardFilter.cropYear = this.headerYear;
    this.dashboardFilter.shipToAccount = this.shipToAccount;
    this.subscription.push(this.seedReplantService.getGrowerListByFilter(this.dashboardFilter, growerFilters).subscribe(result => {
      this.growerList = result;
      this.searchCount = this.growerList.length;
      this.growerList.forEach(grower => {
        grower.businessName = (grower.businessName == null || grower.businessName == '' ?
          (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
          (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
          (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
          : grower.businessName);
        grower.EmailTo = this.emailAddress;
      });
      
      if (this.formdata.gmk != undefined) {
        const grower = this.growerList.find(x => x.gmk === this.formdata.gmk);
        this.formdata.growerEmail = grower?.email;
      }

      this.growerLoading = false;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.growerLoading = false;
      this.loaderService.setLoaderStatus(false);
    }));
  }

  getProductList() {
    this.subscription.push(this.seedReservationService
      .getSeedReservationMasterData(false)
      .subscribe(
        (result: any) => {
          this.productList = result.productLines;
          this.marketingBrandList = result.marketingBrands;
          this.confirmationMsg = result.confirmationMessage;
        },
        (error) => LolLoggerService.error(error)
      ));
  }

  enableAllCheckBoxes(isChecked) {
    if (isChecked) {
      this.showTabs = true;
      this.selectedItems.forEach(x => {
        x.selected = true;
      });
      this.selectedCount = this.selectedItems.length;
    }
    else {
      this.showTabs = false;
      this.selectedItems.forEach(x => {
        x.selected = false;
      });
      this.selectedCount = 0;
    }
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.showTabs = true;
      this.selectedCount = this.selectedCount + 1;
    }
    else {
      this.selectedCount = this.selectedCount - 1;
      const checked = this.selectedItems.filter(x => x.selected == true);
      if (checked && checked.length == 0) {
        this.showTabs = false;
      }
    }
  }

  onAccountInputChange(event) {
    if (event && event.accountNumber) {
      this.firstLoad = this.firstLoad + 1;
      this.formdata.accountName = event.accountName;
      this.formdata.parentAccountNumber = event.parentNumber;
      this.shipToAccount = event.accountNumber;
      this.getGrowerListByAccount();
      this.getSalesRepresentativeDetails();
      this.formdata.gmk = null;
      this.formdata.growerEmail = '';
      this.formdata.retailAccountID = null;
      this.formdata.sellerAccountNumber = null;
    }
    else {
      this.formdata.accountName = null;
      this.formdata.gmk = null;
      this.formdata.growerEmail = '';
      this.formdata.retailAccountID = null;
      this.formdata.sellerAccountNumber = null;
      this.shipToAccount = 0;
      this.growerList = [];
      this.sellerData = [];
      this.selectedItems = [];
      this.dataSource = [];
    }
    if (this.firstLoad > 1) {
      this.selectedItems = [];
      this.dataSource = [];
    }
  }

  onGrowerSelection(event) {
    if (event && event.gmk) {
     
      this.formdata.gmk = event.gmk;
      const grower = this.growerList.find(x => x.gmk === event.gmk);
      this.formdata.growerEmail = grower?.email;
      this.getExistingRecord();
      this.getRetailerAccountID(this.formdata.parentAccountNumber, event.gmk);
    }
    else {
      this.formdata.gmk = null;
      this.formdata.retailAccountID = null;
      this.formdata.growerEmail = null;
      /*this.formdata.growerEmail = null;*/
    }

  }

  onSellerSelection(event) {
    if (event && event.sellerAccountNumber) {
      this.formdata.sellerAccountNumber = event.sellerAccountNumber;
      this.formdata.sellerPhoneNumber = event.sellerPrimaryPhoneNumber;
      this.formdata.sellerEmail = event.sellerEmailAddress;
      this.getExistingRecord();
    }
    else {
      this.formdata.sellerAccountNumber = null;
    }



  }

  accountSearchFn(term: string, item: any) {
    term = term?.toLocaleLowerCase?.() || '';
    return (
      (item.accountName?.toLocaleLowerCase?.() || '').includes(term) ||
      item.accountNumber?.toString()?.includes(term) ||
      (item.address1?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.city?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.state?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.primaryPhoneNumber?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.zipCode?.toLocaleLowerCase?.() || '').includes(term)
    );
  }


  sellerSearchFn(term: string, item: any) {
    term = term?.toLocaleLowerCase?.() || '';
    return (
      (item.sellerAccountName?.toLocaleLowerCase?.() || '').includes(term) ||
      item.sellerAccountNumber?.toString()?.includes(term) ||
      (item.sellerAddress1?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.sellerCity?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.sellerState?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.sellerPrimaryPhoneNumber?.toLocaleLowerCase?.() || '').includes(term) ||
      (item.sellerZipCode?.toLocaleLowerCase?.() || '').includes(term)
    );
  }

  filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return (item.value.toLocaleLowerCase().indexOf(term) > -1 ||
      item.id.toLocaleLowerCase().indexOf(term) > -1);
  }

  keyPressNumbers(event) {
    const numbers = /^[-+]?[0-9]+$/;
    if (!numbers.test(event.key)) {
      return false;
    }
  }

  addReservationRow() {
    this.selectedItems.push({
      productLineId: this.selectedProductLineId ? this.selectedProductLineId : null,
      productLineName: '', 
      marketingBrandId: null,
      marketingBrandName: '',
      quantity: 0,
      selected: false,
      hasError: false,
      marketingBrandFilteredList: this.selectedProductLineId ? this.marketingBrandList.filter(x => x.productLineId == this.selectedProductLineId): this.marketingBrandList
    });
    this.dataSource = [...this.selectedItems];
  }

  onProductOrBrandChange(element, type) {
    if (type === "productLine") {
      element.marketingBrandId = ""
    }

    element.marketingBrandFilteredList = this.marketingBrandList.filter(x => x.productLineId == element.productLineId);
    const productLine = this.productList.find(item => item.id === element.productLineId);
    const marketingBrand = this.marketingBrandList.find(item => item.id === element.marketingBrandId);
    const isDuplicate = element.productLineId  && element.marketingBrandId  && this.selectedItems.some(
      x => x !== element &&
        x.productLineId === element.productLineId &&
        x.marketingBrandId === element.marketingBrandId
    );

    if (isDuplicate) {
      element.hasError = true;
      element.errorMessage = `The combination of ${productLine.value} and ${marketingBrand.value} already exists.`;
      this.isPlaceOrderDisable = true;
      return;
    }


    if (element.productLineId && element.marketingBrandId) {
      element.productLineName = productLine ? productLine.value : '';
      element.marketingBrandName = marketingBrand ? marketingBrand.value : '';
      element.hasError = false;
      element.errorMessage = '';
    } else {
      element.hasError = false;
      element.errorMessage = '';
    }

    this.dataSource = [...this.selectedItems]; // trigger table update
    this.validateRow(element);
    this.selectedProductLineId = this.selectedItems.length > 0
      ? this.selectedItems[this.selectedItems.length - 1].productLineId
      : null;
  }

  setcount() {
    this.dataCount = this.selectedItems.filter(x => x.quantity > 0).length;
    this.isPlaceOrderDisable = this.dataCount > 0 ? false : true;
    this.hasChangeAdded = true;
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { plDataChange: true, labelNo: 'No,go Back to Reservation' });
  }

  navigateTolandingPage() {
    if (this.hasChangeAdded) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No,go Back to Reservation ', dialogType: 'confirm' }
      });
      dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
          const closebutton = document.getElementsByClassName('close-btn')[0] as HTMLElement;
          closebutton.style.display = '';
          this.sliderModelService.close();
          this.router.navigate(['/seed-reservation-landing']);
        }
      });
    }
    else {
      const closebutton = document.getElementsByClassName('close-btn')[0] as HTMLElement;
      closebutton.style.display = '';
      this.sliderModelService.close();
      this.router.navigate(['/seed-reservation-landing']);
    }
  }

  deleteSelectedItems(value) {
    if (value) {
      const itemsToDelete = this.selectedItems.filter(item => item.selected);
      this.selectedItems = this.selectedItems.filter(item => !item.selected);
      this.dataSource = [...this.selectedItems];
      this.selectedProductLineId = this.selectedItems.length > 0
        ? this.selectedItems[this.selectedItems.length - 1].productLineId
        : null;
      this.selectedCount = 0;
      this.showTabs = false;
      this.setcount();
    }
    this.tabNode = '';
  }

  showAddNewItemInput() {
    this.isAddingNewItem = true;
    this.setTableHeight();
  }

  quantityTextChange(productItem) {
    if (/^0/.test(productItem.quantity) && productItem.quantity != '0') {
      productItem.quantity = productItem.quantity.replace(/^0/, '');
    }
    this.validateRow(productItem);
    this.setcount();
  }

  geuValueChange(value: string, element: any) {
    this.isFormValid();

    if (value == 'decrease') {
      const decValue = +element.quantity - 1;
      if (decValue > 0) {
        element.quantity = decValue;
      }
      else {
        element.quantity = 0;
      }
    }
    else {
      if (element.quantity <= 999998) {
        element.quantity = +element.quantity + 1;
      }

    }
    this.validateRow(element);
    this.setcount();
  }

  hasAnyError(): boolean {
    return this.dataSource?.some(item => item.hasError);
  }

  validateEmail(isave = false) {
    this.isNotValid = this.commonService.validateEmail(this.formdata.growerEmail, false);
    if (this.isNotValid && isave) {
      this.toastrService.warning('Enter a valid email.');
    }
    this.matcher = new InputErrorStateMatcher(this.isNotValid);
    return this.isNotValid;
  }

  validateForm(): boolean {
    if (!this.formdata.accountNumber) {
      this.toastrService.error('Account selection is required.');
      return false;
    }
    return true;
  }

  isFormValid(): boolean {
    return this.selectedItems.every(item => {
      if (item.quantity === 0) {
        return true;
      }
      return !!item.productLineId && !!item.marketingBrandId;
    });
  }

  validateRow(element: any) {
    element.hasProductLineError = false;
    element.hasMarketingBrandError = false;

    if (element.quantity > 0) {
      if (!element.productLineId) {
        element.hasProductLineError = true;
      }

      if (!element.marketingBrandId) {
        element.hasMarketingBrandError = true;
      }
    }
  }

  saveOrder() {
    if (!this.validateForm()) {
      return;
    }
    const selectedItems = this.selectedItems.filter(item => item.quantity > 0);
    const hasErrors = selectedItems.some(item =>
      item.hasError === true ||
      (item.errorMessage && item.errorMessage.length > 0)
    );
    if (hasErrors) {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Please resolve errors in selected items before proceeding.');
      return;
    }

    const retailerId = this.formdata?.retailAccountID?.trim();
    const growerEmail = this.formdata?.growerEmail?.trim();
    const emailIsValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(growerEmail);
    if (!retailerId && !growerEmail) {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Retailer Account ID and Grower Email are required for Seed Reservation');
      return;
    }

    if (!retailerId) {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Retailer Account ID is required for Seed Reservation');
      return;
    }

    if (!growerEmail) {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Grower Email is required for Seed Reservation');
      return;
    }

    if (!emailIsValid) {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Please enter a valid Grower Email address');
      return;
    }

    if (selectedItems.length > 0) {
      this.getConfirmation(selectedItems);
    }

  }

  getExistingRecord() {
    if (this.formdata.accountNumber && this.formdata.sellerAccountNumber && this.formdata.gmk) {
      this.loaderService.setLoaderStatus(true);
      const checkObj: any = {};
      checkObj.shipToAccount = this.shipToAccount;
      checkObj.gmk = this.formdata.gmk;
      checkObj.salesRepresentative = this.formdata.sellerAccountNumber;
      this.subscription.push(this.seedReservationService
        .exisitingSeedReservationData(checkObj)
        .subscribe(
          (headerId: any) => {
            if (headerId > 0) {
              this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
              this.seedReservationService.setseedReservationId(headerId, true);
              this.loaderService.setLoaderStatus(false);
              this.router.navigate(['/seed-reservation/seed-reservation-confirmation']);
            }
            this.loaderService.setLoaderStatus(false);
          },
          (error) => LolLoggerService.error(error)
        ));
    }
  }

  openGrowerSliderModel() {
    if (this.formdata.accountNumber && this.formdata.accountNumber != 0) {
      this.sliderModelService.initializeComponentVal(this.formdata.accountNumber);
      this.sliderModelService.toAccountNumber.next(this.formdata.accountNumber);
      this.sliderModelService.growerSearchType.next('SEED_RESERVATION');
      this.sliderModelService.activeSlider('growerSearchSlider');
    }
    else {
      this.toastrService.warning('Select an Account before adding a Grower.');
    }
  }

  getConfirmation(selectedItems: any[]) {
    const retailerId = this.formdata?.retailAccountID?.trim() || '';
    const growerEmail = this.formdata?.growerEmail?.trim() || '';

    const formattedMsg = (this.confirmationMsg || '')
      .replace('{0}', retailerId)
      .replace('{1}', growerEmail);

    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '450px',
      data: { message: formattedMsg, labelYes: 'Yes', labelNo: 'No', dialogType: 'acknowledgement' }
    });

    this.subscription.push(dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.saveAfterConfirm(selectedItems);
      }
    }));

  }

  saveAfterConfirm(selectedItems: any[]) {
    this.loaderService.setLoaderStatus(true);
    if (selectedItems.length > 0) {
      const saveObj: any = {};
      saveObj.shipToAccount = this.shipToAccount;
      saveObj.gmk = this.formdata.gmk;
      saveObj.sellerAccount = this.formdata.sellerAccountNumber;
      saveObj.SellerPhone = this.formdata.sellerPhoneNumber;
      saveObj.sellerEmail = this.formdata.sellerEmail;
      saveObj.growerEmail = this.formdata.growerEmail;
      saveObj.rbaNumber = this.formdata.retailAccountID;
      saveObj.flag = (this.retailerId?.toLowerCase() === this.formdata.retailAccountID?.toLowerCase()) ? true : false;
      saveObj.productDetails = [];
      selectedItems.forEach(x => {
        saveObj.productDetails.push({ productLineId: x.productLineId, marketingBrandId: x.marketingBrandId, units: x.quantity });
      });

      this.isPlaceOrderDisable = true;
      this.subscription.push(this.seedReservationService.SaveSeedReservation(saveObj).subscribe((result: any) => {
        if (result != 0) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          this.toastrService.success('New Reservation Successfully Created.');
          this.seedReservationService.setseedReservationId(result, false);
          this.loaderService.setLoaderStatus(false);
          this.router.navigate(['/seed-reservation/seed-reservation-confirmation']);
        } else {
          this.isPlaceOrderDisable = false;
          this.loaderService.setLoaderStatus(false);
          this.toastrService.error('The Reservation not saved in the system.');
        }
      }))
        , (error) => {
          this.isPlaceOrderDisable = false;
          this.loaderService.setLoaderStatus(false);
          this.toastrService.error('The Reservation not saved in the system.');
          LolLoggerService.error(error);
        };
    }
    else {
      this.loaderService.setLoaderStatus(false);
      //  this.toastrService.warning('Enter a valid email.');
    }
  }

  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }


}

class InputErrorStateMatcher implements ErrorStateMatcher {
  constructor(private errorstate: boolean) { }

  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return this.errorstate;
  }
}
